import { useEffect } from "react";
import { Checkbox } from "@rmwc/checkbox";
import { Radio } from "@rmwc/radio";
import { TextField } from "@rmwc/textfield";
import ExtraAnchors from "./ExtraAnchors.js";
import AddNewComponent from "./AddNewComponent.js";
import { useDispatch, useSelector } from "react-redux";
import EditPriceItem from "../../EditPriceItem/EditPriceItem";
import CurrencyFormat from "react-currency-format";
import NumberInput from "./NumberInput.js";
import CheckOut from "../../Modals/OrderQuote/CheckOut/CheckOut.js";
import WrapAroundConnectionFee from "./WrapAroundConnectionFee";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";
import EngineeringDrawing from "../../SlidePanels/EngineeringDrawing.js";
import * as validate from "../../Modals/validations";
import Certification from "./Certifications.js";
import AdditionalFeatures from "./AdditionalFeatures.js";
import ExtraItemsAddOn from "./ExtraItemsAddOn.js";

import { AddandRemoveComponent, buildingSurfaceChange, extraInformationAction, extraItemsAction, orderExtrasChangeValueFromMainAction } from "../../../action/index.js";
import Overhang from "./Overhang.js";
import ExtraItemsWithoutQuantity from "./ExtraItemsWithoutQuantity.js";

const ExtraOptions = () => {
	const { const_var, params, order_extra_items } = useSelector((state) => state.reducer);
	const isLTBuilding = useSelector((state) => state.reducer.const_var.isLTBuilding);
	const dispatch = useDispatch();

	const capitalizeFirstLetter = (string) => {
		if (string.length === 0) {
			return string;
		}
		return string.charAt(0).toUpperCase() + string.slice(1);
	};

	const handleResize = () => {
		const tooltip = document.getElementsByClassName("popover-info popover-md");
		if (tooltip && tooltip.length > 0) {
			tooltip[0].classList.remove("show");
			tooltip[0].classList.add("hide");
		}
	};

	useEffect(() => {
		window.addEventListener("resize", handleResize);
		return () => {
			window.removeEventListener("resize", handleResize);
		};
	}, []);

	let checkData = false;

	const overhang = const_var.a_p_d_a.overhang;
	const isOldOverhang = overhang && ((overhang?.end?.length > 0) || ( overhang?.side?.length > 0) || (overhang?.both != ""))? false : true;

	let showEndWithLean = false;
	let showSideWithLean = false;
	const_var.leanto?.forEach((lean) => {
		if (lean.leanto_type == 1 || lean.leanto_type == 2) {
			showSideWithLean = true;
		}
		if (lean.leanto_type == 3 || lean.leanto_type == 4) {
			showEndWithLean = true;
		}
	});
	let showItWithZero = [75, 39, 184];
	if (const_var.b_o_J_1[params.p_b_t] == "Custom Buildings" && const_var.post_data?.building?.connection_fee_side == 0 && showSideWithLean == false) {
		const_var.post_data.building.connection_fee_side = undefined;
	}
	if (const_var.b_o_J_1[params.p_b_t] == "Custom Buildings" && const_var.post_data?.building?.connection_fee_end == 0 && showEndWithLean == false) {
		const_var.post_data.building.connection_fee_end = undefined;
	}
	checkData = const_var.post_data?.building?.connection_fee_end != undefined ? true : false;
	let checkDataSide = const_var.post_data?.building?.connection_fee_side != undefined ? true : false;

	if (const_var.a_p_d_a == 0) {
		return null;
	}
	const elementPrice = const_var.UpdatedPriceData.length > 0 && const_var.UpdatedPriceData["elements"] != undefined && const_var.UpdatedPriceData["elements"];

	let chkPermit = "";
	if (const_var.stateManufacturerAcordingAPI != undefined) {
		if (const_var.stateManufacturerAcordingAPI[params.p_s_n] != undefined) {
			chkPermit = const_var.stateManufacturerAcordingAPI[params.p_s_n];
		}
	}

	let checkFlag = false;
	if (params.p_s_n == 29 && (params.m_s_n == 3 || params.m_s_n == 9) && (chkPermit.is_labor_show_in_3d == 1 || chkPermit.is_permit_show_in_3d == true)) {
		checkFlag = true;
	} else {
		if (chkPermit.is_labor_show_in_3d == 1) {
			checkFlag = true;
		}
	}
	let isUserData = localStorage.getItem("userData") ? true : false;

	const installationArray = [
		{ value: 1, label: "Concrete" },
		{ value: 2, label: "Asphalt" },
		{ value: 3, label: "Ground" },
		{ value: 4, label: "Gravel" }
	];

	let fourFeetOnCenterIndex = const_var.ExtraItemsFeaturesArray.findIndex((item) => item?.name === "fourth_center_cost");

	if (isLTBuilding == true) {
		fourFeetOnCenterIndex = const_var.lNTBuildingData["ExtraItemsFeaturesArray"]["centerBuilding"].findIndex((item) => item?.name === "fourth_center_cost");
		if (fourFeetOnCenterIndex > -1) {
			const_var.ExtraItemsFeaturesArray[fourFeetOnCenterIndex] = const_var.lNTBuildingData["ExtraItemsFeaturesArray"]["centerBuilding"]?.[fourFeetOnCenterIndex];
		}
	}

	let checkNatCarport = params.m_s_n == 184;
	let defaultCertificates = const_var.editAPIDataByResponse?.data?.pricing_data?.certificate?.filter((item) => {
		if (item.is_default == "yes" && (item.gauge == 0 || item.gauge == params.gauge_val)) {
			return item;
		}
	});
	let checkFourFeetOrNot = const_var.a_p_d_a?.extra_items?.[0]?.checkbox?.findIndex((item) => item?.name === "fourth_center_cost");
	let buildingStructureDoc = const_var.a_p_d_a?.building_structure?.[0]?.distance_on_center ? const_var.a_p_d_a?.building_structure?.[0]?.distance_on_center : const_var?.defaultDistanceOnCenter;
	let certificateNotMatch =
		const_var.crmSetting.is_Edit && defaultCertificates?.length > 0 ? const_var.defaultDistanceOnCenter != buildingStructureDoc : const_var.DistanceArr?.[params.p_b_t]?.[params.p_r_s] != buildingStructureDoc;

	return (
		<div>
			<div className="building-elements-sec">
				<div className="building-elements-sec-mid">
					<div className="building-elements-sec-mid-scroll">
						<form className="">
							<div className="section-seprator">
								<div className="card-body-inner">
									{/* <Certification /> */}
									<div className="form-group-lg">
										<div className="control-label-bar">
											<label className="control-label">Extra Options</label>
										</div>
										<Overhang isOldOverhang={isOldOverhang} />
										<ExtraItemsWithoutQuantity isOldOverhang={isOldOverhang} />
										{const_var.a_p_d_a?.extra_items?.[0]?.checkbox_quantity?.map((val, index) => {
											let chkFlagForDistanceonCenterItem = false;
											if (const_var.ExtraItemsFeaturesQuantityArray?.[index]?.is_disabled !== undefined) {
												chkFlagForDistanceonCenterItem = const_var.ExtraItemsFeaturesQuantityArray[index].is_disabled == true ? true : false;
											}

											return (
												<div className="control-field-bar extra">
													<div className="control-field">
														<div className="check-group">
															<Checkbox
																checked={const_var.ExtraItemsFeaturesQuantityArray?.[index]?.is_checked ?? false}
																label={val.label + (chkFlagForDistanceonCenterItem ? "(Included)" : "")}
																disabled={const_var.ExtraItemsFeaturesQuantityArray?.[index]?.is_disabled ?? false}
																onChange={(e) => dispatch(extraItemsAction(e.target.value, "extraitemsCheckboxwithQuantity", val, index))}
															/>
															{!chkFlagForDistanceonCenterItem ? (
																<OverlayTrigger
																	trigger="hover"
																	placement={window.innerWidth > 992 ? "left-start" : "bottom"}
																	rootClose={true}
																	overlay={
																		<Popover className="popover-info popover-md">
																			<Popover.Content>
																				<div className="info-content">
																					<p>This item is not shown on the configurator, but gets added to your building design and may increase the price</p>
																				</div>
																			</Popover.Content>
																		</Popover>
																	}
																>
																	<span className="control-info-tip">
																		<i class="icon-eye-off"></i>
																	</span>
																</OverlayTrigger>
															) : null}
														</div>
													</div>
													{const_var.ExtraItemsFeaturesQuantityArray?.[index]?.is_checked ? (
														<div className="control-field-action">
															{const_var.loginSession == true && chkFlagForDistanceonCenterItem == false ? (
																<div className="price-box">
																	<EditPriceItem
																		is_disabled={const_var.ExtraItemsFeaturesQuantityArray?.[index]?.is_checked === true ? "false" : "true"}
																		jsonObj={"extraitems"}
																		jsonObjValue={const_var.ExtraItemsFeaturesQuantityArray?.[index]?.is_checked ?? false}
																		jsonObjKey={val.label}
																		elementObjIndex={index}
																		extraItemType={"extraitemsCheckboxwithQuantity"}
																		priceKey={"ExtraItemsFeaturesQuantityArray"}
																	/>
																</div>
															) : (
																<div className="price-box-type-2">
																	{const_var.hide_price_calculation != 1 && const_var.loginSession == false && elementPrice?.[val.label]?.item_price !== 0 && (
																		<CurrencyFormat value={elementPrice[val.label]?.item_price} displayType={"text"} thousandSeparator={true} prefix={"$"} />
																	)}
																</div>
															)}
														</div>
													) : null}
													{chkFlagForDistanceonCenterItem == false &&
													const_var.ExtraItemsFeaturesQuantityArray?.[index]?.is_checked == true &&
													(checkFourFeetOrNot == -1 &&
													val.name == "bows" &&
													(const_var.crmSetting.is_Edit
														? true
														: certificateNotMatch &&
															const_var.ExtraItemsFeaturesQuantityArray?.[index]?.is_disabled &&
															(params.m_s_n == 87 || params.m_s_n == 8 || params.m_s_n == 121 || params.m_s_n == 181 || params.m_s_n == 17))
														? false
														: true) ? (
														<div className="row mt-2 mb-1">
															<div className="col-12 mt-2">
																<div className="more-info-option extra">
																	<label className="control-label" style={{ marginLeft: "9px" }}>
																		Quantity
																	</label>
																	<div className="floating-label-input">
																		<TextField
																			className=""
																			value={const_var.ExtraItemsFeaturesQuantityArray?.[index]?.quantity ?? ""}
																			maxLength="4"
																			name="quantity"
																			onChange={(e) => {
																				validate.numericCheck(e);
																				dispatch(extraItemsAction(e.target.value, "extraitemsCheckboxValue", val, index));
																			}}
																		/>
																	</div>
																</div>
															</div>
														</div>
													) : null}
												</div>
											);
										})}
										{(params.add_front_lean ||
											params.add_back_lean ||
											(params.add_left_lean && const_var.leanGetDataLeft?.connection_fees?.[0]?.end_cost) ||
											(params.add_right_lean && const_var.leanGetDataRight?.connection_fees?.[0]?.end_cost) ||
											const_var.a_p_d_a?.connection_fees?.[0]?.end_cost !== 0) &&
										const_var.a_p_d_a.connection_fees != undefined &&
										const_var.a_p_d_a.connection_fees.length > 0 &&
										const_var.a_p_d_a.connection_fees[0].end_cost != undefined ? (
											<>
												{checkData == true ? (
													<div className="control-field-bar">
														<div className="control-field">
															<div className="check-group">
																<Checkbox ripple="RipplePropF" label="End Connection Fees" checked="true" />
															</div>
														</div>
														<div className="control-field-action">
															{const_var.post_data.building != undefined && const_var.loginSession == true ? (
																<div className="price-box">
																	<EditPriceItem jsonObj={const_var.post_data.building.connection_fee_end} jsonObjKey="connection_fee_end" />
																</div>
															) : (
																<div className="price-box-type-2">
																	{const_var.hide_price_calculation != 1 &&
																		const_var.loginSession == false &&
																		const_var.post_data?.building?.connection_fee_end != undefined &&
																		const_var.post_data?.building?.connection_fee_end !== 0 && (
																			<CurrencyFormat value={const_var.post_data.building.connection_fee_end} displayType={"text"} thousandSeparator={true} prefix={"$"} />
																		)}
																</div>
															)}
														</div>
													</div>
												) : null}
											</>
										) : null}

										{(params.add_left_lean || params.add_right_lean) && const_var.a_p_d_a?.connection_fees?.[0]?.cost && (
											<>
												{checkDataSide == true ? (
													<div className={const_var?.post_data?.building.leanto?.length > 0 ? "control-field-bar" : "control-field-bar d-none"}>
														<div className="control-field">
															<div className="check-group">
																<Checkbox ripple="RipplePropF" label="Side Connection Fees" checked="true" />
															</div>
														</div>
														<div className="control-field-action">
															{const_var.post_data.building != undefined && const_var.loginSession == true ? (
																<div className="price-box">
																	<EditPriceItem jsonObj={const_var.post_data.building.connection_fee_side} jsonObjKey="connection_fee_side" />
																</div>
															) : (
																<div className="price-box-type-2">
																	{const_var.hide_price_calculation != 1 &&
																		const_var.loginSession == false &&
																		const_var.post_data?.building?.connection_fee_side != undefined &&
																		const_var.post_data?.building?.connection_fee_side !== 0 && (
																			<CurrencyFormat value={const_var.post_data.building.connection_fee_side} displayType={"text"} thousandSeparator={true} prefix={"$"} />
																		)}
																</div>
															)}
														</div>
													</div>
												) : null}
											</>
										)}

										{params.add_left_front_lean_porch && const_var.post_data?.building?.connection_fee_left_front !== 0 && (
											<WrapAroundConnectionFee porch_connection_fee="connection_fee_left_front" name="Left Front Connection Fees" />
										)}

										{params.add_right_front_lean_porch && const_var.post_data?.building?.connection_fee_right_front !== 0 && (
											<WrapAroundConnectionFee porch_connection_fee="connection_fee_right_front" name="Right Front Connection Fees" />
										)}

										{params.add_left_back_lean_porch && const_var.post_data?.building?.connection_fee_left_back !== 0 && (
											<WrapAroundConnectionFee porch_connection_fee="connection_fee_left_back" name="Left Back Connection Fees" />
										)}

										{params.add_right_back_lean_porch && const_var.post_data?.building?.connection_fee_right_back !== 0 && (
											<WrapAroundConnectionFee porch_connection_fee="connection_fee_right_back" name="Right Back Connection Fees" />
										)}

										<AdditionalFeatures elementPrice={elementPrice} />
										<ExtraItemsAddOn elementPrice={elementPrice} />
									</div>
									{const_var.cupolasData != undefined && Object.keys(const_var.cupolasData).length > 0 && params.singleSlope != true && (
										<div className="form-group-lg">
											<div className="control-label-bar">
												<label className="control-label">Cupola</label>
											</div>
											<div className="cupola-option-title">(Click on the cupola to drag it or adjust its size.)</div>
											<div className="cupola-container">
												{Object.keys(const_var.cupolasData).map((key) => {
													const cupolaImage = require(`../../../assets/images/cupolaIcons/${key}.png`);
													let cupola = key.charAt(0).toUpperCase() + key.slice(1).replace(/_/g, " ");
													return (
														<>
															<div className="cupola-item">
																<div className="cupola-image">
																	<img src={`${process.env.REACT_APP_BASE_URL}${cupolaImage}`} alt="cupolaImage" />
																</div>
																<div className="cupola-content">
																	<div className="form-label">{cupola}</div>
																	<NumberInput type={key} />
																</div>
															</div>
														</>
													);
												})}
											</div>
										</div>
									)}
									<div className="form-group-lg">
										<div className="control-label-bar">
											<label className="control-label">Installation Surface</label>
										</div>
										{installationArray.map((value, index) => {
											return (
												<div className="radio-group">
													<Radio
														value={value.value}
														name={"surface"}
														checked={params.p_i_s == value.value ? true : false}
														onClick={(e) => dispatch(buildingSurfaceChange(e.target.value, value.label))}
													>
														<div className="installation-label">
															<img src={process.env.REACT_APP_BASE_URL + require(`../../../assets/images/installation/small/${value.label.toLowerCase()}.png`)} alt={value.label} />
															<span>{value.label}</span>
														</div>
													</Radio>
												</div>
											);
										})}
									</div>
									{const_var.loginSession == false && !checkNatCarport ? (
										<>
											<div className="form-group">
												<div className="row">
													<div className="col">
														<label className="control-label-text">Job Site Level</label>
													</div>
													<div className="col-auto text-right">
														<div className="toggle-group">
															<div class={params.job_site_level == "yes" ? "toggle-switches active" : "toggle-switches"}>
																<span className="toggle-label-control">{capitalizeFirstLetter(params.job_site_level)}</span>
																<input
																	id="jobSite"
																	name="job_site_level"
																	type="checkbox"
																	value={params.job_site_level}
																	checked={params.job_site_level == "yes" ? true : false}
																	onChange={(e) => dispatch(extraInformationAction(e, "jobsite", "no"))}
																/>
																<label for="jobSite"></label>
															</div>
														</div>
													</div>
												</div>

												{!checkNatCarport && (
													<div className="row ">
														<div className="col">
															<label className="control-label-text"> Electricity Available</label>
														</div>
														<div className="col-auto text-right">
															<div className="toggle-group">
																<div class={params.power_avail == "yes" ? "toggle-switches active" : "toggle-switches"}>
																	<span className="toggle-label-control">{capitalizeFirstLetter(params.power_avail)}</span>
																	<input
																		id="power_avail"
																		name="power_avail"
																		type="checkbox"
																		value={params.power_avail}
																		checked={params.power_avail == "yes" ? true : false}
																		onChange={(e) => dispatch(extraInformationAction(e, "power", "no"))}
																	/>
																	<label for="power_avail"></label>
																</div>
															</div>
														</div>
													</div>
												)}

												{const_var.loginSession == false && const_var.order_extra_items.extra_labour != 0 && chkPermit != "" && checkFlag == true ? (
													<div className="row align-items-center">
														<div className="col">
															<label className="control-label-text"> Labor Fee </label>
														</div>
														<OverlayTrigger
															trigger="hover"
															placement={window.innerWidth > 992 ? "left-start" : "bottom"}
															rootClose={true}
															overlay={
																<Popover className="labor-info-popover popover-info popover-md ">
																	<Popover.Content>
																		<div className="info-content">
																			<p>
																				The <strong>â€œLabor Feeâ€</strong> can be a fixed amount or a percentage of the Building Amount/Subtotal, as per the manufacturer.
																			</p>
																		</div>
																	</Popover.Content>
																</Popover>
															}
														>
															<span className="d-flex align-items-center cursor-pointer" style={{ position: "absolute", left: "41px", marginLeft: "41px" }}>
																<i class="icon-info"></i>
															</span>
														</OverlayTrigger>

														<div className="col-6 text-right">
															<div className="price-box-type-2">
																{const_var.hide_price_calculation != 1 && (
																	<CurrencyFormat value={const_var.order_extra_items.extra_labour} displayType={"text"} thousandSeparator={true} prefix={"$"} />
																)}
															</div>
														</div>
													</div>
												) : null}
												{const_var.loginSession == false && const_var.order_extra_items.document_fee != 0 && chkPermit != "" && chkPermit.is_document_show_in_3d == 1 ? (
													<div className="row align-items-center">
														<div className="col">
															<label className="control-label-text">Document Fee</label>
														</div>
														<div className="col-6 text-right">
															<div className="price-box-type-2">
																{const_var.hide_price_calculation != 1 && (
																	<CurrencyFormat value={const_var.order_extra_items.document_fee} displayType={"text"} thousandSeparator={true} prefix={"$"} />
																)}
															</div>
														</div>
													</div>
												) : null}
												{const_var.loginSession == false && const_var.order_extra_items.order_processing_fee != 0 && chkPermit != "" && chkPermit.is_processing_show_in_3d == 1 ? (
													<div className="row align-items-center">
														<div className="col">
															<label className="control-label-text">Processing Fee </label>
														</div>
														<div className="col-auto text-right">
															<div className="price-box-type-2">
																{const_var.hide_price_calculation != 1 && (
																	<CurrencyFormat value={const_var.order_extra_items.order_processing_fee} displayType={"text"} thousandSeparator={true} prefix={"$"} />
																)}
															</div>
														</div>
													</div>
												) : null}
											</div>
											{const_var.loginSession == false && chkPermit != "" && chkPermit.is_permit_show_in_3d == true ? (
												<div className="form-group">
													<div className="row">
														<div className="col-12">
															<label className="control-label">Permit Required</label>
														</div>
														<div className="col-12">
															<div className="radio-group">
																<Radio
																	label="Yes"
																	value="yes"
																	checked={const_var.order_extra_items?.permit == "yes" ? true : false}
																	name="permit"
																	onChange={(e) => dispatch(orderExtrasChangeValueFromMainAction(e, "permit", "no"))}
																/>
																{params.p_s_n == 29 && (params.m_s_n == 3 || params.m_s_n == 9) && order_extra_items?.permit == "yes" ? null : const_var.order_extra_items?.permit ==
																  "yes" ? (
																	<div className="price-box-type-2">
																		{const_var.hide_price_calculation != 1 && const_var.order_extra_items.order_permit_fee != 0 && (
																			<CurrencyFormat value={const_var.order_extra_items.order_permit_fee} displayType={"text"} thousandSeparator={true} prefix={"$"} />
																		)}
																	</div>
																) : null}
															</div>
															<div className="radio-group">
																<Radio
																	label="No"
																	value="no"
																	name="permit"
																	checked={const_var.order_extra_items?.permit == "no" ? true : false}
																	onChange={(e) => dispatch(orderExtrasChangeValueFromMainAction(e, "permit", "no"))}
																/>
															</div>
															{params.m_s_n == 67 ? ( //SE3-T1457
																<div className="radio-group">
																	<Radio
																		label="Customer to Verify"
																		value="cust_verify"
																		name="permit"
																		checked={const_var.order_extra_items?.permit == "cust_verify" ? true : false}
																		onChange={(e) => dispatch(orderExtrasChangeValueFromMainAction(e, "permit", "no"))}
																	/>
																</div>
															) : null}
														</div>
													</div>
												</div>
											) : null}

											{const_var.isMultiSelectDrawingOpt == true && const_var.loginSession == false && isUserData == false && const_var.c_m_a?.[params.p_b_t]?.drawings?.length > 0 && (
												<EngineeringDrawing />
											)}

											<div className="row mb-3 mt-3">
												<div className="col-12">
													<div className="floating-label-input">
														<TextField
															textarea
															fullwidth
															placeholder="Start Typingâ€¦"
															rows={4}
															maxLength={1000}
															onChange={(e) => dispatch(extraInformationAction(e.target.value, "notes"))}
															value={params.additional_note}
															characterCount
															helpText={{ persistent: true }}
														/>
													</div>
												</div>
											</div>
										</>
									) : null}
								</div>
								<div className="card-footer-inner">
									<div className={const_var.loginSession == true ? `add-action add-action-${const_var.inputs.length > 0 ? "open" : "close"}` : "d-none"}>
										{const_var.inputs.length > 0 ? (
											<>
												<div className="control-label-bar">
													<label className="control-label">Add Anchors</label>
												</div>
												<ExtraAnchors />
												<div className="add-more">
													<span className="icon">+</span>{" "}
													<span onClick={(e) => dispatch(AddandRemoveComponent(e, "add", "", "extra_anchors"))} className="text">
														Add more
													</span>
												</div>
											</>
										) : null}
										{const_var.inputs.length == 0 ? (
											<>
												<span className="icon">+</span>{" "}
												<span onClick={(e) => dispatch(AddandRemoveComponent(e, "add", "", "extra_anchors"))} className="text">
													Add Anchors
												</span>
											</>
										) : null}
									</div>
									<div className={`add-action add-action-${const_var.Componentinputs.length > 0 ? "open" : "close"}`}>
										{const_var.Componentinputs.length > 0 ? (
											<>
												<div className="control-label-bar">
													<label className="control-label">Add Other Components</label>
												</div>
												<AddNewComponent />
												<div className="add-more">
													<span className="icon">+</span>{" "}
													<span onClick={(e) => dispatch(AddandRemoveComponent(e, "add", "", "addNewComponent"))} className="text">
														Add more
													</span>
												</div>
											</>
										) : null}
										{const_var.Componentinputs.length == 0 ? (
											<>
												<span className="icon">+</span>{" "}
												<span onClick={(e) => dispatch(AddandRemoveComponent(e, "add", "", "addNewComponent"))} className="text">
													Add Other Components
												</span>
											</>
										) : null}
									</div>
								</div>
							</div>
						</form>
					</div>
				</div>
			</div>
			<CheckOut />
		</div>
	);
};

export default ExtraOptions;
